import { type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  TotalizationRole,
  SSMasterImportRole,
  MailSendRole,
  MailTemplateRole,
  UserRole,
  UserImportRole,
  UserMasterRole,
  DisasterConditionRole,
  TenantRole,
  type CrudPermission,
  type RequiredRole,
} from "../role";
import type { CurrentUser } from "../types/user";

type ProtectedRouteProps = {
  children: ReactNode;
  user: CurrentUser;
  requiredRole: RequiredRole;
};

const ProtectedRoute = ({
  children,
  user,
  requiredRole,
}: ProtectedRouteProps) => {
  const searchParams = new URLSearchParams(useLocation().search);
  const pathName = useLocation().pathname;
  let checkRole: CrudPermission = {
    create: false,
    read: false,
    update: false,
    delete: false,
  };
  switch (requiredRole) {
    case "TotalizationRole":
      checkRole = TotalizationRole(user.m_organization.m_role_id);
      break;
    case "SSMasterImportRole":
      checkRole = SSMasterImportRole(user.m_organization.m_role_id);
      break;
    case "MailSendRole":
      checkRole = MailSendRole(user.m_organization.m_role_id);
      break;
    case "MailTemplateRole":
      checkRole = MailTemplateRole(user.m_organization.m_role_id);
      break;
    case "UserRole":
      checkRole = UserRole(user.m_organization.m_role_id);
      if (!checkRole.read) {
        switch (pathName) {
          case "/account/list/edit":
            if (searchParams.get("user-id") === user.id) {
              checkRole = {
                create: false,
                read: true,
                update: true,
                delete: false,
              };
            }
            break;
          default:
            break;
        }
      }
      break;
    case "UserImportRole":
      checkRole = UserImportRole(user.m_organization.m_role_id);
      break;
    case "UserMasterRole":
      checkRole = UserMasterRole(user.m_organization.m_role_id);
      break;
    case "DisasterConditionRole":
      checkRole = DisasterConditionRole(user.m_organization.m_role_id);
      break;
    case "TenantRole":
      checkRole = TenantRole(user.m_organization.m_role_id);
      break;
    default:
      break;
  }
  console.log(checkRole, requiredRole);
  if (!checkRole.read) {
    return <Navigate to="/forbidden" replace />;
  }
  return <>{children}</>;
};

export default ProtectedRoute;
